import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Quelque chose résiste encore. Réessaie dans un moment.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((entry) => (entry && typeof entry.msg === "string" ? entry.msg : JSON.stringify(entry)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function fetchSiteContent() {
  const response = await client.get(`/site`);
  return response.data;
}

export async function fetchLesson(slug) {
  const response = await client.get(`/lessons/${slug}`);
  return response.data;
}

export async function requestInvitation(payload) {
  const response = await client.post(`/invitations`, payload);
  return response.data;
}

export async function fetchAccessCatalog() {
  const response = await client.get(`/access/catalog`);
  return response.data;
}

export async function registerUser(payload) {
  const response = await client.post(`/auth/register`, payload);
  return response.data;
}

export async function loginUser(payload) {
  const response = await client.post(`/auth/login`, payload);
  return response.data;
}

export async function logoutUser() {
  const response = await client.post(`/auth/logout`);
  return response.data;
}

export async function fetchCurrentUser() {
  const response = await client.get(`/auth/me`);
  return response.data;
}

export async function createCheckoutSession(payload) {
  const response = await client.post(`/payments/checkout/session`, payload);
  return response.data;
}

export async function fetchCheckoutStatus(sessionId) {
  const response = await client.get(`/payments/checkout/status/${sessionId}`);
  return response.data;
}